import { WorkspaceConfigDto } from "./dto"

export interface WorkspaceConfig {
  readonly config: WorkspaceConfigDto
  readonly lastModified: string | null
}

export interface WorkspaceConfigStorage {
  get(): WorkspaceConfig | null

  set(config: WorkspaceConfig): void

  clear(): void
}

export class NoopWorkspaceConfigStorage implements WorkspaceConfigStorage {
  get(): null {
    return null
  }

  set(config: WorkspaceConfig): void {}

  clear(): void {}
}
